import axios from "axios";
import store from "./store/store";
import { router } from '@/router.js'

const ROOT_URL = 'https://api.alvdigital.net/' // NEW LIVE!!


// const ROOT_URL = 'https://devapp.alvdev.com/nemanja/api/index.php/'                // nemanja
// const ROOT_URL = 'https://api.alvdev.com/'           // goran
// const ROOT_URL = 'https://alvdigital.de/johannes/api/api_vue_v2.php/'            // johannes
// const ROOT_URL = 'https://alvdigital.de/james/api/api_vue_v2.php/'               // james
// const ROOT_URL = 'https://devapp.alvdev.com/patrick/api/index.php/'             // patrick
// const ROOT_URL = 'https://devapp.alvdev.com/patrick/api/index.php/'              // patrick
// const ROOT_URL = 'https://devapp.alvdev.com/patrick-clone1/api/index.php/'       // patrick-clone1
// const ROOT_URL = 'https://devapp.alvdev.com/patrick-clone2/api/index.php/'       // patrick-clone2
// const ROOT_URL = 'https://alvdigital.de/dev/api/api_vue_v2.php/'                 // dev
// const ROOT_URL = 'https://alvdigital.de/mirror/api/api_vue_v2.php/'              // mirror
// const ROOT_URL = 'https://app.alvdigital.net/api/api_vue_v2.php/'                // live
// const ROOT_URL = 'https://alvdigital.de/strale_api/api/api_vue_v2.php/'          // strale
// const ROOT_URL = 'https://www.alvdigital.de/lisa/api/api_vue_v2.php/'            // Lisa developing
// const ROOT_URL = 'https://alvdigital.de/originalshares/api/api_vue_v2.php/'      // Original Shares 2.0 backend
// const ROOT_URL = 'https://devapp.alvdev.com/mihailo/api/index.php/'             // mihailo 
// const ROOT_URL = 'https://devapp.alvdev.com/ahmad/api/index.php/'               // ahmad 
// const ROOT_URL = 'https://api.miroslav.alvdev.com/' // miroslav

const FILE_BULK_UPLOAD_URL = "label/tracks/files";

export default {
    rootUrl: ROOT_URL,
    // GET
    /** Returns axios Promise and catches errors.
     *  Returns axios Promise over get() and catchs errors.
     *  @param {string} url API-URL.
     *  @return {String[]} Returns a Array of objects. */
    getResponse(url) {
        return axios
            .get(url, this.getConfig())
            .then((response) => {
                return response.data;
            })
            .catch((error) => {
                if (error.response.data.response.errorMsg == "lang_ERROR_API_METHOD_LOGIN_FAILED") {
                    localStorage.clear()
                    router.go()
                    router.push('/login')
                } else {
                    console.log("CATCHING API ERRORS")
                    console.log(error.response.data)
                    return error.response.data
                }
            });
    },

    /** Get the TOKEN for the headers of a call from the localStorage.
     *  @return {{headers:{ Authorization: String}}} */
    getConfig() {
        return {
            headers: { Authorization: "Bearer " + store.getters.getUserToken() },
        };
    },

    // TODO: Dropdown function, separate it from postLogin

    // TODO: use getDropdownvalues function for that!
    /** Get LANGUAGE CONSTS from DB.
     *  Gets the language consts from the DB via lang param (de/en/ja)
     *  even before the user is logged in.
     * @param {string} lang chosen language.
     * @return {<Promise> => {}} Object with the lang consts. */
    async getLanguageConstants(lang) {
        let url = ROOT_URL + "languages/" + lang;

        let timestamp = Date.now();

        let cacheRaw = window.localStorage.getItem(url)
        let cache = null
        if (cacheRaw) {
            try {
                cache = JSON.parse(cacheRaw)
            } catch (e) {
                cache = null
            }
        }

        // Check if cached language constants are older than 1 day
        if (!cache || cache.expiration < timestamp - 24 * 60 * 60 * 1000 || typeof cache.data !== 'object') {
            const languageConstants = await axios.get(url).then((response) => response.data);

            window.localStorage.setItem(url, JSON.stringify({
                expiration: timestamp,
                data: languageConstants,
            }));

            return languageConstants;
        }

        return cache.data;
    },

    //Publishing reminders
    getReminders(dir, keyword) {
        let url = ROOT_URL + dir + "/" + keyword;
        return this.getResponse(url)
    },

    // only used for tracks/releases in label contracts for testing serverside sorting!
    getListData2(
        dir,
        page = "1",
        sortBy = [],
        sortDesc = [false],
        searchParams = "",
        fields = ""
    ) {
        let url = ROOT_URL + dir;
        // paging
        url += "?page=" + page;
        // Sorting
        url += "&sort=" + (sortDesc[0] ? "-" + sortBy[0] : "+" + sortBy[0]);
        // filter (optional)
        url += searchParams !== "" ? "&" + searchParams : "";
        // fields (optional)
        url += fields !== "" ? "&" + fields : "";

        return this.getResponse(url);
    },

    /** Returns Array with objects for LIST PAGES.
     *  Sets the URL together with filter params and uses the function getResponse
     *  to get an array with objects back.
     * @param {string} dir directory which is calling this function.
     * @param {string[]} fields which fields are required.
     * @param {string} searchParams string of filter params.
     * @param {string} page used for serverside paging.
     * @return {<Promise> => String[]} list returns a Array of objects. */
    getListData(dir, page = "1", searchParams = "", fields = "") {
        let url = ROOT_URL + dir;
        // paging
        url += "?page=" + page;
        // filter (optional)
        url += searchParams !== "" ? "&" + searchParams : "";
        // fields (optional)
        url += fields !== "" ? "&" + fields : "";

        return this.getResponse(url);
    },

    /** Returns an Object with DETAILS for a single ALVID Entity.
     *  Sets the URL together and use the function getResponse
     *  to get an Object with details.
     * @param {string} dir directory which is calling this function.
     * @param {string} alvId alvId of the entity.
     * @return {<Promise> => String[]} list returns a Array of objects. */
    getDetailsById(dir, alvId, extraParam = "") {
        let url =
            ROOT_URL + dir + "/" + alvId + (extraParam !== "" ? extraParam : "");
        return this.getResponse(url);
    },

    /** Gets an Object with FILTERed results.
     * Depending on the given parameters gives back the results.
     * @param {string} dir directory which is calling this function.
     * @param {string} params given parameters.
     * @return {string[]} an array of the filtered results. */
    getFilteredResults(dir, params, page = 1) {
        let url = ROOT_URL + dir + "?" + params + "&page=" + page;
        return this.getResponse(url);
    },

    // TODO: rework
    /** Get the options for Label-Filter DROPDOWN.
     * Used in Label > Releases > Label-Filter based on the company id.
     * @param {string} dir directory which is calling this function.
     * @param {number} companyId company id that is currently chosen.
     * @return {string[]} a array of the Label-Filter options for this company. */
    getReleasesLabelFilterOptions(dir, companyId) {
        let url = ROOT_URL + dir + "?fields=name&labelCompanyId=" + companyId;
        return this.getResponse(url);
    },

    getContractsByType(domain, type) {
        let url = ROOT_URL + "contracts/" + domain + "?search=&type=" + type
        return this.getResponse(url)
    },

    // TODO: rework ?
    // /** Get contracts for specific work(s)
    //  * Used in Publishing > Works > ACTION: "Add contracts".
    //  * @param {string} search user search input.
    //  * @param {string} selectedWorks a string of the selected work ids. */
    getContractsByWorkIds(search, selectedWorks) {
        let url =
            ROOT_URL +
            "contracts/publishing?search=" +
            search +
            "&workIds=" +
            selectedWorks.join(",");
        return this.getResponse(url);
    },

    // TODO: maybe use "getFilteredResults" instead?
    /** Search in the Add Works Dialog in Contracts > Publishing > Edit Form > Works Panel > Button Add New.
     * Action "Add new" in contracts > publishing use this function to search for contracts.
     * Strale
     * /publishing/works/?search=wine&publishingCompanyId=27
     * @param {string} search user input to search for.
     * @param {string} selectedContracts a string of the selected contract ids. */
    getWorksByContractId(dir, contractId, search) {
        let url =
            ROOT_URL +
            dir +
            "?addWorks&contractId=" +
            contractId +
            "&search=" +
            search;
        return this.getResponse(url);
    },

    /** Get a list of items for an autocomplete field based on a SEARCH parameter
     * Used for Autocomplete fields.
     * @param {string} dir directory which is calling this function.
     * @param {string} search user search input.
     * @param {string} specParam if spec param needed. */

    getAutocompleteSearch(dir, search, specParam) {
        let url =
            ROOT_URL + dir + "?search=" + search + (specParam ? "&" + specParam : "");
        return this.getResponse(url);
    },

    /** Get a list of items by TYPE across all A-Z entity types (persons, groups...etc)
     * @param {string} type type of A-Z entry.  */

    getAzByType(type) {
        let url = ROOT_URL + "az?type=" + type + "&visibility=yes";
        return this.getResponse(url);
    },

    /** Get a list of A-Z Distributors and Societies with visible=yes, i.e. for Account > Mappings
     * @param {string} direction either import or export, results in different lists */
    getAzForMapping(direction) {
        let url = ROOT_URL + "az?mappingsDirection=" + direction + "&visibility=yes";
        return this.getResponse(url);
    },

    getImporters(domain) {
        let url = ROOT_URL + domain + "/importers";
        return this.getResponse(url);
    },


    getIncomeImporters(domain) {
        let url = ROOT_URL + "publishing/income?importer=true";
        return this.getResponse(url);
    },

    /** Get the list of customer invoices for ACCOUNT > COMPANIES
     * @param {string} customerNumber the internal ID of an ALV customer, e.g. DE01000044 for ACT. */

    getAccountInvoices(customerNumber) {
        let url = ROOT_URL + "account/companies/" + customerNumber + "/invoices";
        return this.getResponse(url);
    },

    // Get the list of Mappings abbreviations by Source
    getAccountMappingsSources() {
        let url = ROOT_URL + "account/mappings/sources";
        return this.getResponse(url);
    },

    /** Get Progress in percentage of a triggered process.
     *  After starting a process (e.g. Upload file) this function will
     *  gives back a Object with progress in percentage and status (finished/running).
     *  @param processId can be file id or just process id.
     */

    getProgressOfProcess(processId, polling) {
        let url = ROOT_URL + "progress/" + processId;

        return axios.get(url, this.getConfig()).then((response) => {
            if (response.data.status === "finished") {
                clearInterval(polling);
            }
            return response.data;
        });
    },

    /** Get the status of a currently running statement.
     *  Function for publishing and label statements.
     *  @param {String} dir directory which is calling this function
     */
    getStatusOfStatementsRun(dir) {
        let url = ROOT_URL + "checkStatus/" + dir;

        return axios.get(url, this.getConfig()).then((response) => {
            return response.data;
        });
    },

    /** Get a region by search param.
     * Get a array with regions that fits to the search param.
     * @param {string} search full text search. */
    getRegion(search, language) {
        /**
         * Since we do not have all the translations for all languages
         * language will be set to "en" in order for the region to be found
         */
        if (language === "ja" || language === "jp" || language === "ko") {
            language = "en";
        }

        let url = ROOT_URL + "region/" + language + "?search=" + search;
        return axios.get(url, this.getConfig()).then((response) => response.data);
    },

    /**
     * Used when credentials already exists.
     * Api call for testing if entered credentials are correct.
     * @param {string} dir directory which is calling this function.
     * @param {string} id id of credentials for testing.
     */

    getCredentialsConnectionStatus(dir, id) {
        let url = ROOT_URL + dir + "/" + id + "?testConnection";

        return axios
            .get(url, this.getConfig())
            .then((response) => response.data)
            .catch((error) => {
                return error.response.data;
            });
    },

    /**
     * Used to sync contacts from Mailchimp to ALV AZ Persons
     * Api call for synchronizing contacts between mailchimp and ALV.
     * @param {string} dir directory which is calling this function.
     * @param {string} id id of credentials for synchronizing.
     */
    synchronizeContacts(dir, id) {
        let url = ROOT_URL + dir + "/" + id + "?synchronizeContacts";
        return axios
            .get(url, this.getConfig())
            .then((response) => response.data)
            .catch((error) => {
                return error.response.data;
            });
    },
    /**
     * Used from Work Action Dropdown.
     * Api call for testing if credentials exists or if it is properly set.
     * @param {string} dir directory which is calling this function.
     * @param {string} type type of credentials for checking.
     */

    getCredentialsStatus(dir, type) {
        let url = ROOT_URL + dir + "?type=" + type;

        return axios
            .get(url, this.getConfig())
            .then((response) => response.data)
            .catch((error) => {
                return error.response.data;
            });
    },

    // TODO: comment!!
    getSpecificDropdownValues(dir, alvId, spec) {
        let url = ROOT_URL + dir + "/" + alvId + "/" + spec;

        return axios
            .get(url, this.getConfig())
            .then((response) => response.data)
            .catch((error) => error.response.data);
    },

    // TODO: comment!!
    getDropdownValues(dir, keyword) {
        let url = ROOT_URL + dir + "/" + keyword;

        return axios
            .get(url, this.getConfig())
            .then((response) => response.data)
            .catch((error) => error.response.data);
    },

    // TODO: comment!! > e.g. Works Action: Testcalculation GEMA (data for form in Dialog)
    getSpecificFormData(dir, params = "") {
        let url = ROOT_URL + dir + (params !== "" ? "?" + params : "");
        // let url = ROOT_URL + dir + '?' + params
        return this.getResponse(url);
    },

    // TODO: comment!!
    getFileBulkUploadUrl() {
        return ROOT_URL + FILE_BULK_UPLOAD_URL;
    },
    getRootUrl() {
        return ROOT_URL;
    },

    /** Get AI suggestions for International Work Title (backend proxies OpenAI)
     * @param {string} domesticTitle
     */
    getIntlTitleSuggestions(domesticTitle) {
        return this.triggerAction('publishing/works', { domesticTitle }, { action: 'aiSuggestIntlTitle' })
    },

    /** GEMA Repertoire: list all versions (token-based search, without shares)
     * @param {string} workNumber base work number (without -001)
     */
    getGemaRepertoireVersions(workNumber) {
        return this.triggerAction('publishing/works', { workNumber }, { action: 'gemaRepertoireSearch' })
    },

    /** Check if GEMA work versions exist in ALV
     * @param {array} workVersions array of full work version numbers (e.g. ["32515598-001", "32515598-002"])
     */
    checkGemaVersionsExistence(workVersions) {
        return this.triggerAction('publishing/works', { workVersions }, { action: 'checkGemaVersionsExistence' })
    },

    /** Generate AZ Persons KEY NAME via backend (romaji), returns "LAST, FIRST"
     * @param {string} firstName
     * @param {string} lastName
     */
    getAzPersonsKeyNameTransliteration(firstName, lastName) {
        return this.triggerAction('az/persons', { firstName, lastName }, { action: 'aiTransliterateKeyName' })
    },

    /** Get AI analysis for a single income error row
     * @param {string} alvId alvId of the income error row, e.g. "ALV0319626RC"
     * @param {string} lang current UI language (e.g. "de", "en", "ja", "ko")
     */
    getIncomeErrorAiAnalysis(alvId, lang) {
        let url = ROOT_URL + "publishing/income/" + alvId + "/aiAnalysis";
        if (lang) {
            url += "?lang=" + encodeURIComponent(lang);
        }
        return axios
            .get(url, this.getConfig())
            .then((response) => response.data)
            .catch((error) => error.response.data);
    },

    // Download a shareable Dashboard Quicklinks template by alvId.
    // Streams the file from the dedicated BE endpoint (bypasses statsecure.php
    // ownership check, which forbids cross-account downloads).
    downloadQuicklinksTemplate(alvId) {
        const url = ROOT_URL + "dashboard/quicklinks/templates/" + encodeURIComponent(alvId) + "/download";
        const config = Object.assign({}, this.getConfig(), { responseType: "blob" });
        return axios.get(url, config).then((response) => {
            const disposition = response.headers["content-disposition"];
            if (!disposition) {
                throw new Error("Missing Content-Disposition header — refusing to fall back to a generic filename");
            }
            const match = disposition.match(/filename="?([^"]+)"?/);
            if (!match || !match[1]) {
                throw new Error("Could not extract filename from Content-Disposition header");
            }
            const filename = match[1];
            const fileURL = window.URL.createObjectURL(new Blob([response.data]));
            const fileLink = document.createElement("a");
            fileLink.href = fileURL;
            fileLink.setAttribute("download", filename);
            document.body.appendChild(fileLink);
            fileLink.click();
        });
    },

    // TODO: comment!!
    getFileFromALV(path) {
        let tempPath = path;
        let filename = "";

        if (path.includes("alvtoken")) {
            tempPath = path.substring(0, path.indexOf("&alvtoken"));
        }

        if (path.includes("file=")) {
            filename = tempPath.substring(tempPath.indexOf("file=") + 5);
        } else if (path.includes("?t=")) {
            filename = tempPath.replace(/^.*[\\\/]/, "");
            filename = filename.substring(0, filename.indexOf("?t="));
        } else {
            filename = tempPath.replace(/^.*[\\\/]/, "");
        }

        if (filename.includes("&type=")) {
            filename = filename.replace(/\&type=.*/, "")
        }
        return axios({
            url: path,
            method: "GET",
            responseType: "blob",
        }).then((response) => {
            var fileURL = window.URL.createObjectURL(new Blob([response.data]));
            var fileLink = document.createElement("a");

            fileLink.href = fileURL;
            fileLink.setAttribute("download", filename);
            document.body.appendChild(fileLink);

            fileLink.click();
        });
    },

    // Fetch a secure ALV file URL as a Blob so it can be previewed inline.
    // The BE serves these URLs with `Content-Disposition: inline`, which
    // forces a download when the URL is used directly as an <iframe src>. By
    // fetching the bytes here and letting the caller build a blob: object URL,
    // the disposition header no longer applies and the browser renders the file
    // inline. Auth travels in the URL (alvtoken), so no extra headers are needed.
    getFileBlobFromALV(path) {
        return axios({
            url: path,
            method: "GET",
            responseType: "blob",
        }).then((response) => response.data);
    },

    // TODO: comment!!
    getProfitAndLossResult(dir, params) {
        let url = ROOT_URL + dir + "?" + params;
        return this.getResponse(url);
    },

    getPriceForReleaseAndCustomer(releaseId, invoiceId) {
        let url = `${ROOT_URL}label/releases/${releaseId}/prices/${invoiceId}`
        let response = this.getResponse(url);
        return response;
    },

    // DELETE
    /** DELETE specific Entry/Entries.
     * Depending on the given ids Entry/Entries will be deleted.
     * @param {string} dir directory which is calling this function.
     * @param {string} ids ALV ID(s) of the entries to delete. */

    deleteEntries(dir, ids, uniqueId) {
        let url = ROOT_URL + dir + (uniqueId ? "?uniqueId=" + uniqueId : "");

        let config = this.getConfig();
        config["data"] = ids;

        return axios.delete(url, config).then((response) => response.data);
    },

    deleteFile(dir, params, data = {}) {
        let url = ROOT_URL + dir + (params ? params : "");

        let config = this.getConfig();
        config["data"] = data;

        return axios.delete(url, config).then((response) => response.data);
    },

    // PUT
    /** Upload a file to the DB.
     * Upload a file, parameterized. The file needs to be in a FormData.
     * @param {*} dir directory which is calling this function.
     * @param {*} formData the file in a FormData.
     * @param {*} params optional params for upload. */
    putFile(dir, formData, params) {
        let url = ROOT_URL + dir + (params ? params : "");
        let config = this.getConfig();
        config["headers"]["Content-Type"] = "multipart/form-data";

        let header = Object.assign(config, {
            onUploadProgress: function (progressEvent) {
                store.commit(
                    "setUploadProgressbarValue",
                    parseInt(
                        Math.round((progressEvent.loaded * 100) / progressEvent.total)
                    )
                );
            }.bind(store),
        });

        return axios
            .put(url, formData, header)
            .then((response) => response.data)
            .catch((error) => error.response.data);
    },

    // POST: post, add, launch/run, change, save

    /** LOGIN with credentials.
     *  returns the object with error messages or the token and user data.
     * @param {string} username username the user typed in.
     * @param {string} password password the user typed in.
     * @return {<Promise> => string} the access token. */
    postLogin(username, password) {
        return axios({
            method: "POST",
            url: ROOT_URL,
            data: {
                username: username,
                userpass: password,
            },
        }).then((response) => response.data);
    },

    addRowToDataTable(dir, data, params) {
        let url = ROOT_URL + dir + "?" + params;
        let h = this.getConfig();

        return axios({
            method: "POST",
            headers: h["headers"],
            url: url,
            data: data,
        })
            .then((response) => response.data)
            .catch((error) => error.response.data);
    },

    addMultipleRowsToDataTable(dir, metaData, context) {
        let url = ROOT_URL + dir + "?" + context;
        let h = this.getConfig();

        return axios({
            method: "POST",
            headers: h["headers"],
            url: url,
            data: metaData,
        })
            .then((response) => response.data)
            .catch((error) => error.response.data);
    },

    /** Mapping import — COMMIT phase.
     *  Runs the real import against a file that was already uploaded with
     *  `phase=preflight` (via putFile). The blob is NOT re-uploaded, a new
     *  worker is started for the existing `file_id`.
     *
     *  The import options are NOT remembered between preflight and commit and
     *  the BE does not check that they match, so the caller has to replay
     *  exactly what the dry-run ran with (see MappingImportDialog).
     *
     *  @param {{dir:String, fileId:(String|Number), mappingAlvId:(String|Number),
     *           tag:?String, extra:?Object}} opts `extra` is merged into the body,
     *           e.g. { searchWorkTitle: 'yes' }.
     *  @return {<Promise>} { error, fileId, processId } — poll the NEW processId. */
    confirmMappingImport(opts) {
        return this.triggerMappingImportPhase("commit", opts || {});
    },

    /** Mapping import — ABANDON phase.
     *  Deletes the temporary upload behind `fileId`. Runs no worker and returns
     *  synchronously, so there is nothing to poll. This is the only thing that
     *  cleans the file up, so fire it whenever the user walks away from a
     *  preflight summary.
     *  @param {{dir:String, fileId:(String|Number)}} opts
     *  @return {<Promise>} { error: -1, fileId, abandoned: true }. */
    abandonMappingImport(opts) {
        return this.triggerMappingImportPhase("abandon", opts || {});
    },

    /** Shared trigger for the mapping-import commit/abandon phases on a file
     *  that is already uploaded. Only the preflight phase rides on putFile
     *  (PUT + query params); these two are plain POSTs against the domain
     *  endpoint with a JSON body and no re-upload.
     *  Backend: POST <dir>?action=mappingImportProcess { file_id, phase, ... }. */
    triggerMappingImportPhase(phase, { dir, fileId, mappingAlvId, tag, extra }) {
        let data = Object.assign(
            { file_id: fileId, phase: phase },
            mappingAlvId !== null && mappingAlvId !== undefined ? { mappingAlvId: mappingAlvId } : {},
            tag !== null && tag !== undefined && tag !== "" ? { tag: tag } : {},
            extra || {}
        );

        return this.triggerAction(dir, data, { action: "mappingImportProcess" });
    },

    // TODO LATER: use the triggerAction function instead !
    // and change the api call to action="addContracts"
    addContracts(dir, metaData) {
        let url = ROOT_URL + dir + "?addContracts";

        let h = this.getConfig();
        return axios({
            method: "POST",
            headers: h["headers"],
            url: url,
            data: metaData,
        })
            .then((response) => response.data)
            .catch((error) => error.response.data);
    },

    /** Add the works to contracts.
     * Action "Add contract" in publishing > works use this funtion to add the works to the contracts.
     *
     * @param {string} dir directory which is calling this function.
     * @param {string} workIds a string of comma separated selected work IDs.
     * @param {string} contractIds a string of comma separated selected contract IDs. */
    addContractsToWorks(dir, workIds, contractIds) {
        let url = ROOT_URL + dir + "?addContracts";

        let h = this.getConfig();
        // TODO: rework, see comment above function "addContracts"!
        return axios({
            method: "POST",
            headers: h["headers"],
            url: url,
            data: {
                workIds: workIds,
                contractIds: contractIds,
            },
        })
            .then((response) => response.data)
            .catch(function () {
                console.log("ERROR!");
            });
    },
    // NOT IN USE ANYMORE ( using "addMultipleRowsToDataTable" instead)
    // /** Add the works to contract.
    //  * add one or more works to a specific contract.
    //  *
    //  * @param {string} dir directory which is calling this function.
    //  * @param {string} workIds a string of comma separated selected work IDs.
    //  * @param {string} contractIds alvId of the contract.
    //  * @param {string} uniqueId unique Id for  temp saving. */
    // addWorksToContract(dir, workIds, contractId, uniqueId){
    //     let url = ROOT_URL + dir + '/' + contractId + '?addWorks' + (uniqueId != '' ? '&uniqueId=' + uniqueId : '')
    //     let h = this.getConfig()

    //     return axios({
    //         method: 'POST',
    //         headers: h["headers"],
    //         url: url,
    //         data: workIds
    //     })
    //     .then(response => response.data)
    //     .catch(function() { console.log('ERROR!') })
    // },

    /** Add the works to sheet.
     * add one or more works to a specific sheet.
     *
     * @param {string} dir directory which is calling this function.
     * @param {string} workIds a string of comma separated selected work IDs.
     * @param {string} sheetId alvid of the sheet
     */
    addWorksToSheet(dir, workIds, sheetId) {
        let url = ROOT_URL + dir + "/" + sheetId + "?addWorks";
        let h = this.getConfig();

        return axios({
            method: "POST",
            headers: h["headers"],
            url: url,
            data: workIds,
        })
            .then((response) => response.data)
            .catch(function () {
                console.log("ERROR!");
            });
    },

    /** Change selected company.
     * @param {string} dir directory which is calling this function.
     * @param {string} newId new selected company id. */

    changeSelectedCompany(dir, newId) {
        let token = this.getConfig();

        return axios({
            method: "POST",
            headers: token["headers"],
            url: ROOT_URL + dir + "?select&" + dir + "CompanyId=" + newId,
        }).then((response) => response.data);
    },
    /** Change selected company on settings page.
     * @param {String} newAlvId new selected company ALVID */
    changeSelectedOverAllCompany(newAlvId) {
        let token = this.getConfig();

        return axios({
            method: "POST",
            headers: token["headers"],
            url: ROOT_URL + "companies?setCompany",
            data: { alvId: newAlvId },
        })
            .then((response) => response.data)
            .catch((error) => error.response.data);
    },

    /** Save an edit form with all necessary metadata and params.
     * @param {String} dir directory which is calling this function.
     * @param {String} alvId alvId of the entry.
     * @param {{Object}} metaData object with all data.
     * @param {Boolean} isNew is it a new entry?
     * @param {String} uniqueId unique id for the backend.
     */
    saveEditForm(dir, alvId, metaData, isNew, uniqueId) {
        let url = ROOT_URL + dir + (isNew ? "" : "/" + alvId);

        if (uniqueId !== "" && uniqueId !== undefined) {
            url += "?uniqueId=" + uniqueId;
        }

        let h = this.getConfig();
        return axios({
            method: "POST",
            headers: h["headers"],
            url: url,
            data: metaData,
        })
            .then((response) => response.data)
            .catch((error) => {
                if (error.response.data.response.errorMsg == "lang_ERROR_API_METHOD_LOGIN_FAILED") {
                    localStorage.clear()
                    router.go()
                    router.push('/login')
                } else {
                    console.log("CATCHING API ERRORS")
                    console.log(error.response.data)
                    return error.response.data
                }
            });
    },

    /** Save for an inline editing data table outside an edit form.
     * @param {String} dir directory which is calling this function.
     * @param {{Object}} metaData object with all data.
     */

    saveDataTables(dir, metaData) {
        let url = ROOT_URL + dir;
        let h = this.getConfig();

        return axios({
            method: "POST",
            headers: h["headers"],
            url: url,
            data: metaData,
        })
            .then((response) => response.data)
            .catch(() => {
                console.log("Error!");
            });
    },
    // CURRENTLY NOT IN USE!
    // TODO: COMMENT
    saveDataTableRow(dir, keyword, metaData, id) {
        let url = ROOT_URL + dir + "?" + keyword;

        if (id !== "" && id !== undefined) {
            url += "?alvId=" + id;
        }

        let h = this.getConfig();

        return axios({
            method: "POST",
            headers: h["headers"],
            url: url,
            data: metaData,
        })
            .then((response) => response.data)
            .catch(function () {
                console.log("ERROR!");
            });
    },

    // TODO: COMMENT
    async saveSettings(alvId, metaData) {
        let url = ROOT_URL + "account/settings/" + alvId;
        let h = this.getConfig();

        return await axios({
            method: "POST",
            headers: h["headers"],
            url: url,
            data: metaData,
        })
            .then((response) => response.data)
            .catch(() => {
                console.log("Error!");
            });
    },

    /** GET: list company default mappings for a given (companyId, companyType).
     * @param {Number} companyId DB id of the publishing/label company
     * @param {String} companyType 'publishing' | 'label'
     * @return {<Promise> => { defaults: [...] }}
     */
    getCompanyDefaultMappings(companyId, companyType) {
        let url = ROOT_URL + "account/settings/company-default-mappings"
                + "?companyId=" + encodeURIComponent(companyId)
                + "&companyType=" + encodeURIComponent(companyType);
        return this.getResponse(url);
    },

    /** PUT: upsert one or more (statement_type, language) -> mapping_id selections.
     *  mappingId: null deletes the row. Response mirrors GET (full state).
     * @param {{companyId:Number, companyType:String, items:Array<{mappingType:String, language:String, mappingId:?Number}>}} payload
     */
    putCompanyDefaultMappings(payload) {
        let url = ROOT_URL + "account/settings/company-default-mappings";
        let h = this.getConfig();

        return axios({
            method: "PUT",
            headers: h["headers"],
            url: url,
            data: payload,
        })
            .then((response) => response.data)
            .catch((error) => {
                if (error.response && error.response.data && error.response.data.response
                    && error.response.data.response.errorMsg === "lang_ERROR_API_METHOD_LOGIN_FAILED") {
                    localStorage.clear()
                    router.go()
                    router.push('/login')
                } else {
                    console.log("CATCHING API ERRORS")
                    if (error.response) console.log(error.response.data)
                    return error.response ? error.response.data : { error: 1 }
                }
            });
    },

    /** Method used for performing actions from dropdown in list page.
     * @param {String} dir directory which is calling this function.
     * @param {{Object}} metaData object with all data.
     * @param {{Object}} queryParams object with query params, can have multiple values which can be "key":"value" or "key2" : ""
     */
    triggerAction(dir, metaData, queryParams) {
        let url = ROOT_URL + dir;
        let queryParamsString = "";
        let queryParamsArray = [];

        if (Object.keys(queryParams).length > 0) {
            for (let [key, value] of Object.entries(queryParams)) {
                let str = key + (value != "" ? "=" + value : "");
                queryParamsArray.push(str);
            }
        }

        if (queryParamsArray.length) {
            queryParamsString = "?" + queryParamsArray.join("&");
            url += queryParamsString;
        }

        let token = this.getConfig();

        return axios({
            method: "POST",
            headers: token["headers"],
            url: url,
            data: metaData,
        })
            .then((response) => response.data)
            .catch((error) => {
                if (error.response.data.response.errorMsg == "lang_ERROR_API_METHOD_LOGIN_FAILED") {
                    localStorage.clear()
                    router.go()
                    router.push('/login')
                } else {
                    console.log("CATCHING API ERRORS")
                    console.log(error.response.data)
                    return error.response.data
                }
            });
    },

    /** Method to fetch the currently selected Company's full object
     * @param {String} dir directory which is calling this function (for publishing or label companies)
     * @param {String} id id of the currently selected publishing or label company
     */
    getCompanyObject(dir, id) {
        let alvId = "ALV" + String(id).padStart(9, "0") + "PC";
        let companyObject = ROOT_URL + dir + alvId;
        return this.getResponse(companyObject);
    },

    async getExistingNotifications() {
        let url = ROOT_URL + 'notifications'
        return await this.getResponse(url)
    },

    /** Fetch context help content from Storyblok
     * @param {String} context The help context (e.g. 'PublishingWorksEdit')
     * @param {String} section Optional section parameter
     * @param {String} language Optional language parameter (defaults to current locale)
     * @return {Array} Array of Storyblok stories or empty array on error
     */
    async fetchContextHelp(context, section = null, language = null) {
        try {
            let metaData = { context }
            if (section) {
                metaData.section = section
            }
            if (language) {
                metaData.language = language
            }

            let queryParams = { "action": "fetchContextHelp" }
            let response = await this.triggerAction('help', metaData, queryParams)

            if (response.error === -1 && response.response.stories) {
                return response.response.stories
            }

            return []
        } catch (error) {
            // Error fetching context help - silent fail
            return []
        }
    },

    /** Fetch a single Storyblok story by UUID
     * @param {String} storyUuid The UUID of the story to fetch
     * @param {String} language Optional language parameter (defaults to current locale)
     * @return {Object} Storyblok story object or null on error
     */
    async fetchStoryByUuid(storyUuid, language = null) {
        try {
            let metaData = { by_uuid: storyUuid }
            if (language) {
                metaData.language = language
            }

            let queryParams = { "action": "fetchStoryByUuid" }
            let response = await this.triggerAction('help', metaData, queryParams)

            if (response.error === -1 && response.response.story) {
                return response.response.story
            }

            return null
        } catch (error) {
            // Error fetching story - silent fail
            return null
        }
    }
};
